import type { SVGProps } from "react";

const TicketIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 7.5V5.83333C2.5 5.39131 2.67559 4.96738 2.98816 4.65482C3.30072 4.34226 3.72464 4.16667 4.16667 4.16667H15.8333C16.2754 4.16667 16.6993 4.34226 17.0118 4.65482C17.3244 4.96738 17.5 5.39131 17.5 5.83333V7.5C16.837 7.5 16.2011 7.76339 15.7322 8.23223C15.2634 8.70107 15 9.33696 15 10C15 10.663 15.2634 11.2989 15.7322 11.7678C16.2011 12.2366 16.837 12.5 17.5 12.5V14.1667C17.5 14.6087 17.3244 15.0326 17.0118 15.3452C16.6993 15.6577 16.2754 15.8333 15.8333 15.8333H4.16667C3.72464 15.8333 3.30072 15.6577 2.98816 15.3452C2.67559 15.0326 2.5 14.6087 2.5 14.1667V12.5C3.16304 12.5 3.79893 12.2366 4.26777 11.7678C4.73661 11.2989 5 10.663 5 10C5 9.33696 4.73661 8.70107 4.26777 8.23223C3.79893 7.76339 3.16304 7.5 2.5 7.5Z"
        stroke="currentColor"
        strokeWidth="1.45833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 4.16667V5.83333" stroke="currentColor" strokeWidth="1.45833" strokeLinecap="round" />
      <path d="M10 9.16667V10.8333" stroke="currentColor" strokeWidth="1.45833" strokeLinecap="round" />
      <path d="M10 14.1667V15.8333" stroke="currentColor" strokeWidth="1.45833" strokeLinecap="round" />
    </svg>
  );
};

export default TicketIcon;
